import { getTokens } from "utils/Utils";

export const getHeaders = () => {
  return {
    //TODO instead of reading from storage, can save in memory when loaded
    authorization: `${getTokens().token}`,
  };
};
